var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg00Cover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "00 AURA \xB7 Case study cover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-grad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#080B18",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#12182E",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080B18",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "light-#6D5DFB-0.45",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6D5DFB",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D5DFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "light-#46C5FF-0.28",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46C5FF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hp-floor",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6D5DFB",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D5DFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp-band",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#585F78",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#262C45",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12182E",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp-shade",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02040C",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp-side",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02040C",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#02040C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp-rim",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46C5FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#46C5FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C5FF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "00 AURA \\xB7 Case study cover"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 1440,
    height: 900,
    fill: "url(#bg-grad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Lighting / Violet",
    cx: 980,
    cy: 470,
    rx: 600,
    ry: 420,
    fill: "url(#light-#6D5DFB-0.45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Lighting / Blue rim",
    cx: 1320,
    cy: 60,
    rx: 360,
    ry: 280,
    fill: "url(#light-#46C5FF-0.28)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Product render \\xB7 replace with 3D render",
    transform: "translate(700 130) scale(1.1429)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor light",
    cx: 280,
    cy: 470,
    rx: 230,
    ry: 38,
    fill: "url(#hp-floor)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Headband"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 300 C 118 70, 442 70, 442 300",
    fill: "none",
    stroke: "url(#hp-band)",
    strokeWidth: 34,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 290 C 140 108, 420 108, 424 290",
    fill: "none",
    stroke: "#080B18",
    strokeOpacity: 0.55,
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 150 C 210 104, 350 104, 400 150",
    fill: "none",
    stroke: "#B2B6FE",
    strokeOpacity: 0.55,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Yokes"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 252,
    width: 28,
    height: 74,
    rx: 12,
    fill: "#3A415B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 252,
    width: 28,
    height: 74,
    rx: 12,
    fill: "#3A415B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 258,
    width: 4,
    height: 58,
    rx: 2,
    fill: "#B3BACE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 258,
    width: 4,
    height: 58,
    rx: 2,
    fill: "#B3BACE",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ear cup L"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 300,
    width: 144,
    height: 200,
    rx: 64,
    fill: "#151A28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 300,
    width: 144,
    height: 200,
    rx: 64,
    fill: "url(#hp-shade)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 300,
    width: 144,
    height: 200,
    rx: 64,
    fill: "url(#hp-side)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.75,
    y: 300.75,
    width: 142.5,
    height: 198.5,
    rx: 63.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 340,
    width: 80,
    height: 120,
    rx: 40,
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ear cup R"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 300,
    width: 144,
    height: 200,
    rx: 64,
    fill: "#151A28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 300,
    width: 144,
    height: 200,
    rx: 64,
    fill: "url(#hp-shade)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 300,
    width: 144,
    height: 200,
    rx: 64,
    fill: "url(#hp-side)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.75,
    y: 300.75,
    width: 142.5,
    height: 198.5,
    rx: 63.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.18,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 340,
    width: 80,
    height: 120,
    rx: 40,
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rim light",
    d: "M506 336 C 516 380, 516 420, 506 464",
    fill: "none",
    stroke: "url(#hp-rim)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Status LED",
    cx: 436,
    cy: 400,
    r: 6,
    fill: "#6D5DFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 400,
    r: 12,
    fill: "none",
    stroke: "#6D5DFB",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "Portfolio \\xB7 UI Design \\xB7 2026",
    fill: "#D0D4FE",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 1.92
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 108.56
  }, "PORTFOLIO \xB7 UI DESIGN \xB7 2026")), /*#__PURE__*/React.createElement("g", {
    id: "Title"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AURA",
    fill: "#FFFFFF",
    fontFamily: "Inter",
    fontSize: 88,
    fontWeight: 600,
    letterSpacing: 14
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 377.44
  }, "AURA")), /*#__PURE__*/React.createElement("text", {
    id: "3D Glass Product Experience",
    fill: "#D0D4FE",
    fontFamily: "Inter",
    fontSize: 36,
    fontWeight: 600,
    letterSpacing: -0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 439.68
  }, "3D Glass Product Experience"))), /*#__PURE__*/React.createElement("text", {
    id: "A premium headphone concept: design syst",
    fill: "#CDD4E9",
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: 400,
    letterSpacing: -0.09
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 496.84
  }, "A premium headphone concept: design system, glass"), /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 524.84
  }, "surfaces, product components and responsive screens.")), /*#__PURE__*/React.createElement("g", {
    id: "Badge / Neutral"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Pill",
    x: 80,
    y: 620,
    width: 110.02,
    height: 24,
    rx: 12,
    fill: "#DCE7FF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Label",
    fill: "#CDD4E9",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 92,
    y: 636.56
  }, "Design system"))), /*#__PURE__*/React.createElement("g", {
    id: "Badge / Neutral"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Pill",
    x: 202.02,
    y: 620,
    width: 132.69,
    height: 24,
    rx: 12,
    fill: "#DCE7FF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Label",
    fill: "#CDD4E9",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 214.02,
    y: 636.56
  }, "Component library"))), /*#__PURE__*/React.createElement("g", {
    id: "Badge / Neutral"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Pill",
    x: 346.7,
    y: 620,
    width: 126.17,
    height: 24,
    rx: 12,
    fill: "#DCE7FF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Label",
    fill: "#CDD4E9",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 358.7,
    y: 636.56
  }, "Desktop + mobile"))), /*#__PURE__*/React.createElement("g", {
    id: "Badge / Neutral"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Pill",
    x: 484.88,
    y: 620,
    width: 98.47,
    height: 24,
    rx: 12,
    fill: "#DCE7FF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Label",
    fill: "#CDD4E9",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 496.88,
    y: 636.56
  }, "Accessibility"))), /*#__PURE__*/React.createElement("text", {
    id: "Mahta \\xB7 UI Designer \\xB7 Concept project, n",
    fill: "#989EB2",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0.12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 80,
    y: 832.56
  }, "Mahta \xB7 UI Designer \xB7 Concept project, not a real product")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg00Cover);
export default __webpack_public_path__ + "static/media/00-Cover.478c56d8acb9f66e1c6f3263a938f62e.svg";
export { ForwardRef as ReactComponent };